import { Component, OnInit } from "@angular/core";
import { MatLegacySnackBar as MatSnackBar } from "@angular/material/legacy-snack-bar";
import { ActivatedRoute } from "@angular/router";
import { Lightbox } from "ngx-lightbox";
import { environment } from "src/environments/environment";
import { Location } from "@angular/common";
import { OrderService } from "src/services/order.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { OwlOptions } from "ngx-owl-carousel-o";
import { SafrattiOrderDetail } from "src/models/safratti-order-detail";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { MatTableDataSource } from "@angular/material/table";
import { PolicyDocumentServiceFactory } from "src/services/factory/policy-document-service-factory";
import { StorageService } from "src/services/storage.service";
import { CompanyService } from "src/services/company.service";
import { GTSService } from "src/services/gts.service";
import { TplService } from "src/services/tpl.service";

@Component({
  selector: "app-safratti-order-detail",
  templateUrl: "./safratti-order-detail.component.html",
  styleUrls: ["./safratti-order-detail.component.css"],
})
export class SafrattiOrderDetailComponent implements OnInit {
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    responsive: {
      0: {
        items: 1,
      },
    },
    nav: false,
  };

  formDisabled: boolean = true;
  albums: any = [];
  policyFront: any;
  safrattiPolicyId: string;
  orderDetail: SafrattiOrderDetail;
  carImagesList: any;
  public slideIndex = 1;
  docContainerName: string = "safratti-policy-book";
  companies = [];
  safrattiLables = [];
  convertToBase64: string;
  travelerDetailDataSource: MatTableDataSource<any>;
  travelerHistory: any;
  tDDisplayedColumns = [
    "relation",
    "firstName",
    "middleName",
    "lastName",
    "gender",
    "passportNo",
    "dateOfBirth",
  ];

  policycopyDocumentUrl: SafeResourceUrl;
  receiptDocumentUrl: SafeResourceUrl;
  termsconditionDocumentUrl: SafeResourceUrl;
  private _certificateBlob: Blob;
  private _receiptBlob: Blob;
  private _termsBlob: Blob;

  constructor(
    private lightbox: Lightbox,
    private order: OrderService,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private _policyDocumentServiceFactory: PolicyDocumentServiceFactory,
    private snackBar: MatSnackBar,
    private location: Location,
    private sanitizer: DomSanitizer,
    private _gtsService: GTSService,
    private _companyService: CompanyService,
    private tplService: TplService,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    const id = +this.route.snapshot.paramMap.get("id");
    this.order.getOrderDetail(id).subscribe((orderDetail) => {
      this.orderDetail = orderDetail;
      this.safrattiPolicyId = orderDetail.policyId;
      this.travelerHistory = orderDetail.travelersDetails;
      this.travelerDetailDataSource = new MatTableDataSource(
        this.travelerHistory,
      );

      this.tplService.getSafrattiLabels(orderDetail.companyId).subscribe(
        (res) => {
          this.safrattiLables = res;
        },
        (err) => {
          console.log(err);
        },
      );
      this._companyService
        .getCompanyById(orderDetail.companyId)
        .subscribe((res) => {
          const safratti = res.safratti;
          const pdfUrl = environment.cdnUrl + "/company/" + safratti;
          this.convertImageToBase64(pdfUrl).subscribe((converted64) => {
            this.convertToBase64 = converted64;
          });
        });

      if (orderDetail.certificateUrl) {
        this._fetchAndEmbed(orderDetail.certificateUrl, (blob, url) => {
          this._certificateBlob = blob;
          this.policycopyDocumentUrl = url;
        });
      }

      if (orderDetail.receiptUrl) {
        this._fetchAndEmbed(orderDetail.receiptUrl, (blob, url) => {
          this._receiptBlob = blob;
          this.receiptDocumentUrl = url;
        });
      }

      if (orderDetail.termsAndConditionsUrl) {
        this._fetchAndEmbed(orderDetail.termsAndConditionsUrl, (blob, url) => {
          this._termsBlob = blob;
          this.termsconditionDocumentUrl = url;
        });
      }
    });
  }

  private _fetchAndEmbed(
    apiUrl: string,
    callback: (blob: Blob, safeUrl: SafeResourceUrl) => void,
  ): void {
    this.http.get(apiUrl, { responseType: "blob" }).subscribe((blob) => {
      const objectUrl = URL.createObjectURL(blob);
      const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      callback(blob, safeUrl);
    });
  }

  downloadDocument(blob: Blob, fileName: string): void {
    if (!blob) return;
    const objectUrl = URL.createObjectURL(blob);
    const anchor = document.createElement("a");
    anchor.href = objectUrl;
    anchor.download = fileName;
    anchor.click();
    URL.revokeObjectURL(objectUrl);
  }

  downloadCertificate(): void {
    this.downloadDocument(this._certificateBlob, "certificate.pdf");
  }

  downloadReceipt(): void {
    this.downloadDocument(this._receiptBlob, "receipt.pdf");
  }

  downloadTerms(): void {
    this.downloadDocument(this._termsBlob, "terms-and-conditions.pdf");
  }

  convertImageToBase64(imageUrl: string): Observable<string> {
    return this.http
      .get(imageUrl, { responseType: "blob" })
      .pipe(switchMap((blob: Blob) => this.convertBlobToBase64(blob)));
  }

  convertBlobToBase64(blob: Blob): Observable<string> {
    const reader = new FileReader();

    return new Observable<string>((observer) => {
      reader.onloadend = () => {
        const base64String = reader.result as string;
        observer.next(base64String);
        observer.complete();
      };

      reader.readAsDataURL(blob);
    });
  }
  dateformate(val: any) {
    const date = new Date(val);
    if (date.toString() == "Invalid Date") {
      return (
        val.split("-")[2] + "/" + val.split("-")[1] + "/" + val.split("-")[0]
      );
    } else {
      return (
        date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
      );
    }
  }
  onChangeEvent(t: any) {}
  goBack(): void {
    this.location.back();
  }

  open(index: number): void {
    this.lightbox.open(this.albums, index);
  }

  getPessangerList() {}

  formatOrderDate(val: any) {
    if (!val) return '';
    const [datePart, timePart] = val.split("T");

    const utcDate = new Date(`${datePart}T${timePart}Z`);

    const kuwaitOffset = 3 * 60 * 60 * 1000; // Kuwait is UTC+3 hours
    const kuwaitDate = new Date(utcDate.getTime() + kuwaitOffset);

    const hours = String(kuwaitDate.getUTCHours()).padStart(2, "0");
    const minutes = String(kuwaitDate.getUTCMinutes()).padStart(2, "0");
    const seconds = String(kuwaitDate.getUTCSeconds()).padStart(2, "0");
    const kuwaitTimeString = `${hours}:${minutes}:${seconds}`;

    const kuwaitDateFormatted = `${String(kuwaitDate.getUTCDate()).padStart(
      2,
      "0",
    )}/${String(kuwaitDate.getUTCMonth() + 1).padStart(
      2,
      "0",
    )}/${kuwaitDate.getUTCFullYear()}`;
    return `${kuwaitDateFormatted} ${kuwaitTimeString}`;
  }
}
